import React, { useState, useEffect } from 'react';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { ToolsContext } from '../../context/ToolsContext';
import './ToolsContainer.css';
import { getTool } from '../../utils/toolsHelper';

/** ToolsContainer posiciona la barra de herramientas en pantalla según la configuración,
* y renderiza dentro de ella los componentes (herramientas) hijos.
*/
const ToolsContainer = ({ children, position = 'left' }) => {

    const { config } = useGlobalVariablesContext();
    // Configuración obtenida desde el contexto de configuración
    const toolbarTool = getTool(config?.TOOLS, 'toolbar');
    const conf = toolbarTool?.params;
    const toolbarRightTool = getTool(config?.TOOLS, 'toolbarRight');
    const rightConf = toolbarRightTool?.params;

    // Estilos para la barra de herramientas, con posición top y left desde la configuración
    const [styles, setStyles] = useState({
        top: conf?.top || 0,
        left: conf?.left || 0,
    });

    useEffect(() => {
        const visorElement = document.getElementById("visor");

        if (visorElement) {
            // Obtenemos la posición del contenedor visor en relación con la pantalla
            const rect = visorElement.getBoundingClientRect();

            let newTop, newLeft;

            if (position === 'right') {
                // Para la barra derecha, usar configuración específica
                newTop = rect.top + (rightConf?.top || 0);
                newLeft = rect.left + (rightConf?.left || 0);
            } else {
                // Para la barra izquierda (por defecto)
                newTop = rect.top + (conf?.top || 0);
                newLeft = rect.left + (conf?.left || 0);
            }

            // Actualizamos el estado de las posiciones
            setStyles({
                top: newTop,
                left: newLeft,
            });
        }
    }, [conf, rightConf, position]); // Recalcular cuando conf cambie

    return (
        // Renderizamos la barra de herramientas con los estilos calculados
        <div className={`toolbar-tools ${position === 'right' ? 'toolbar-right' : ''}`} style={styles}>
            <div className="toolbar-content">
                {children} {/* Aquí se renderizan los elementos hijos dentro del contenedor */}
            </div>
        </div>

    );
};

export default ToolsContainer;
